import { CaretIcon } from "../../../assets";
import React from "react";
import {
  OrderTypes,
  SortByType,
  SortByValuesType,
} from "../../../../../domain/entities/fetch-entities";

type SortyByHeaderProps = {
  headerText: string;
  onChange: () => void;
  value: SortByValuesType;
  headerKey: SortByType;
};

export const SortByHeader = ({
  headerText,
  onChange,
  value,
  headerKey,
}: SortyByHeaderProps): React.ReactElement => (
  <section>
    {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
    <section
      onClick={onChange}
      className="flex flex-row items-center justify-center"
    >
      <span className="mr-[10px] text-[11px]">{headerText}</span>
      <section className="h-[14px] w-[14px] items-center justify-center">
        <CaretIcon
          width={15}
          height={15}
          fill={headerKey === value.sort_by ? "#147EFB" : "#8f96a3"}
          className={
            value.order_by === OrderTypes.ASC && headerKey === value.sort_by
              ? ""
              : "rotate-180"
          }
        />
      </section>
    </section>
  </section>
);
